import { render, staticRenderFns } from "./PaginaImportacionResultados.vue?vue&type=template&id=12ee0d05"
import script from "./PaginaImportacionResultados.vue?vue&type=script&lang=js"
export * from "./PaginaImportacionResultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports